






















































import Vue, { PropOptions } from 'vue';
import { moment } from '@/class';
import { NOC } from '@/class/common/const';
import { INews } from '@/class/models/typed/news';
// const Paginate = require('vuejs-paginate');
// Vue.component('paginate', Paginate);

export default Vue.extend({
  name: 'SimpleList',
  props: {
    items: Array as PropOptions<INews[]>,
    categories: Array as PropOptions<NOC.NEWS.ICategory[]>,
    selectedItem: String,
    nowPage: Number,
    noItemsText: {
      type: String,
      default: '現在通知がありません',
    },
    rows: Number,
    from: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      page: 0,
      pages: 0,
      /** 1度に表示するページリンクの数 */
      displayAtOncePage: 5,
      pageArray: [] as number[],
      newPageArray: [] as number[],
      begin: 0,
      pageCountNum: 0,
      /** 1ページあたりに表示する行の数 */
      dispItemSize: 10,
      currentPage: '',
    };
  },
  mounted() {
    this.createPageArray();
    this.page = this.nowPage || 1;
    if (this.nowPage === 0) {
      this.page = 0;
    }
  },
  watch: {
    items() {
      this.createPageArray();

    // if (this.pageArray.length > 0) {
    //     this.page = this.nowPage;
    // } else {
    //     this.page = 0;
    // }
      this.page = 0;
    },
  },
  computed: {
    getItems(): INews[] {
      return this.items;
    },
    totalPageSkill(): number {
      return Math.ceil(this.getItems.length / this.dispItemSize);
    },
    // isStartPage(): boolean { // 旧ページネーション
    //   return (this.page === 0);
    // },
    // isEndPage(): boolean { // 旧ページネーション
    //   return ((this.page + 1) * this.dispItemSize >= this.getItems.length);
    // },
    pageCount(): number {
      // return Math.ceil(this.getItems.length / this.dispItemSize);
      return Math.ceil(this.rows / this.dispItemSize);
    },
    countDispOncePages(): number {
      return Math.ceil(this.pageCountNum / this.displayAtOncePage);
    },
    dispItems(): INews[] {
      if (this.from.match('News')) {
        const nowPage = this.page - 1 < 0 ? 0 : this.page - 1;
        // console.log("nowPage: " + nowPage);
        const startPage = nowPage * this.dispItemSize;
        return this.getItems.slice(startPage, startPage + this.dispItemSize);
      } else {
        return this.getItems;
      }
    },
    showPages(): number[] {
      return this.pageArray.slice(this.begin, this.begin + this.displayAtOncePage);
    },
  },
  methods: {
    clickHandler() {
      this.$emit('currentPage', this.page);
      this.$emit('getAlertList');
    },
    fncChangeDateToInputForm(date: string) {
      return moment.fncChangeDateToInputForm(new Date(date)).replace(/-/g, '.');
    },
    openDetaile(data: any, key: any) {
      this.$emit('openDetaile', data, key);
      // this.$emit('currentPage', this.page);
    },
    category(category: string) {
      const found = this.categories.find((c) => c.type === category);
      return found ? found.title : '';
    },
    // showFirst() { // 旧ページネーション
    //   this.page = 0;
    //   this.begin = 0;
    //   this.pages = 0;
    // },
    // showLast() { // 旧ページネーション
    //   if (this.page === this.pageCountNum - 1 || this.pageCountNum <= 0) {
    //     return;
    //   }
    //   this.page = Math.floor((this.getItems.length - 1) / this.dispItemSize);
    //   this.begin = this.displayAtOncePage * (this.countDispOncePages - 1);
    //   this.pages = this.countDispOncePages - 1;
    // },
    createPageArray() {
      this.pageCountNum = Math.ceil(this.getItems.length / this.dispItemSize);
      this.newPageArray = [];

      for (let i = 1; i <= this.pageCountNum; i++) {
        this.newPageArray.push(i);
        // this.pageArray.push(i);
      }
      this.pageArray = this.newPageArray;
    },
    showPage(index: number) {
      const half = Math.floor(this.displayAtOncePage / 2);
      if (half < index && !((this.getItems.length - index) < half)) {
        this.begin = index - half;
      } else if ((index - half) <= 0) {
        this.begin = 0;
      }
      this.page = index as number;
    },
    setColor(category: string) {
    // console.log(category)
      const found = this.categories.find((c) => c.type === category);
      return found ? found.color : '#182863';
    },
    setBackground(category: string) {
    // console.log(category)
      const found = this.categories.find((c) => c.type === category);
      return found ? found.background : '#DCE5F8';
    },
  },
});
